import React from "react";

import ProjectNavigator from "../projectNavigatorContainer";

class NextProjectNavigator extends React.Component {
  render() {
    return (
      <ProjectNavigator
        project={this.props.project}
        direction="next"
        handleRouteLoad={this.props.handleRouteLoad}
      />
    );
  }
}
export default NextProjectNavigator;
